import { useMutation } from 'react-query';
import type { UseMutationOptions } from 'react-query';

import type { ContactSupportViaServiceCloudVars } from '../types';
import {
  contactSupportViaServiceCloud,
  getContactSupportViaServiceCloudKey,
} from '../util';

export type UseContactSupportViaServiceCloudParam = UseMutationOptions<
  Response,
  unknown,
  ContactSupportViaServiceCloudVars
>;

export const useContactSupportViaServiceCloud = (
  useMutationOptions?: UseContactSupportViaServiceCloudParam,
) => {
  return useMutation({
    ...useMutationOptions,
    mutationKey: getContactSupportViaServiceCloudKey(),
    mutationFn: contactSupportViaServiceCloud,
  });
};
